import { NavigationSectionKey } from 'components/Navigation/navigation-utils';

const NavigationItemKey = Object.freeze({
    LOBBY: 'lobby',
    RUBRICS: 'rubrics',
    ASSIGNMENTS: 'assignments',
    QUIZZES: 'quizzes',
    ORAL_ASSESSMENTS: 'oral-assessments',
    PEOPLE: 'people',
    DESIGN_ACTIVITY: 'design-activity',
    TUTORIAL: 'tutorial',
    SETTINGS: 'settings',
});

const NAVIGATION_DEFINITIONS = [
    {
        key: NavigationItemKey.LOBBY,
        textKey: 'nav.lobby',
        fallback: 'Course Lobby',
        link: '/',
        icon: 'home',
        section: NavigationSectionKey.PLATFORM,
        roles: ['instructor', 'ta', 'student'],
    },
    {
        key: NavigationItemKey.RUBRICS,
        textKey: 'nav.rubrics',
        fallback: 'Rubrics',
        link: '/rubrics',
        icon: 'dashboard',
        section: NavigationSectionKey.PLATFORM,
        roles: ['instructor', 'ta', 'student'],
    },
    {
        key: NavigationItemKey.ASSIGNMENTS,
        textKey: 'nav.assignments',
        fallback: 'Assignments',
        link: '/assignments',
        icon: 'task',
        section: NavigationSectionKey.COURSEWORK,
        roles: ['instructor', 'ta', 'student'],
    },
    // TODO: Uncomment these entries when their routes are available.
    // {
    //     key: NavigationItemKey.QUIZZES,
    //     textKey: 'nav.quizzes',
    //     fallback: 'Quizzes',
    //     link: '/quizzes',
    //     icon: 'exam',
    //     section: NavigationSectionKey.COURSEWORK,
    //     roles: ['instructor', 'ta', 'student'],
    // },
    // {
    //     key: NavigationItemKey.ORAL_ASSESSMENTS,
    //     textKey: 'nav.oral-assessments',
    //     fallback: 'Oral Assessments',
    //     link: '/oral-assessments',
    //     icon: 'mic',
    //     section: NavigationSectionKey.COURSEWORK,
    //     roles: ['instructor', 'ta', 'student'],
    // },
    {
        key: NavigationItemKey.PEOPLE,
        textKey: 'nav.people',
        fallback: 'People',
        link: '/people',
        icon: 'teams',
        section: NavigationSectionKey.COURSEWORK,
        roles: ['instructor', 'ta'],
    },
    // {
    //     key: NavigationItemKey.DESIGN_ACTIVITY,
    //     textKey: 'nav.design-activity',
    //     fallback: 'Design Activity',
    //     link: '/design-activity',
    //     icon: 'ai',
    //     section: NavigationSectionKey.COGNITIVE,
    //     roles: ['instructor', 'ta', 'student'],
    // },
    // {
    //     key: NavigationItemKey.TUTORIAL,
    //     textKey: 'nav.tutorial',
    //     fallback: 'Tutorial',
    //     link: '/tutorial',
    //     icon: 'video',
    //     section: NavigationSectionKey.UTILITY,
    //     roles: ['instructor', 'ta', 'student'],
    // },
    {
        key: NavigationItemKey.SETTINGS,
        textKey: 'nav.settings',
        fallback: 'Settings',
        link: '/settings',
        icon: 'settings',
        section: NavigationSectionKey.UTILITY,
        roles: ['instructor', 'ta', 'student'],
    },
];

const getNavigationItems = (role, t) =>
    NAVIGATION_DEFINITIONS.filter((item) => item.roles.includes(role || 'instructor')).map((item) => ({
        ...item,
        text: t(item.textKey, item.fallback),
    }));

export { NavigationItemKey, NAVIGATION_DEFINITIONS, getNavigationItems };
